export default function getLocalCacheVersions() {
  return JSON.parse(window.localStorage.getItem('cacheVersion')) || {}
}
